package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Pomodoro_session(
  public val id: String,
  public val date_start: String,
  public val date_end: String?,
  public val status: String,
  public val timer_minutes: Long,
  public val started_at: Long,
  public val ended_at: Long?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
